<template>
  <div class="order">
    <div class="head">
      <div class="head-nav-bar">
        <div class="left">
          <van-icon v-if="$route.params.bId" name="arrow-left" class="search-icon" @click="$router.go(-1)"/>
          <span v-if="$route.params.bId">对应发货单</span>
          <span v-else>发货单</span> 
        </div>
        <div class="right" @click="_onSendtoRnPage">
          <van-image :src="require('@/styles/img/icon_add.png')" />
        </div>
      </div>
      <div class="search-box">
        <van-search v-model="svalue" shape="round" clearable placeholder="请输入发货单号/单位/地点" background="transparent" :left-icon="require('@/styles/img/icon_search.png')" @search="onSearch"/>
      </div>
    </div>
    <div class="cont" >
      <van-tabs v-model="active" @click="onClick">
        <van-tab v-for="(item,index) in tabs" :key="index" :name="item.id" :title="item.label">
        </van-tab>
      </van-tabs>
      <div>
          <!-- 列表页 -->
          <invoice-list :channel="status"></invoice-list>
      </div>
    </div>
    <!-- 新增订单弹窗弹窗 -->
    <van-popup class="addOrderPop" v-model="addOrderShow" position="top" close-on-click-overlay :close-on-popstate="true">
      <div class="addOrderPop-box">
        <van-cell title="新增发货单" :to="{ path: '/AddInvoice' }">
          <template #icon>
            <van-image class="search-icon" :src="require('@/styles/img/icon_add_invoice.png')" />
          </template>
        </van-cell>
        <van-cell title="原材料配送" :to="{ path: '/AddMaterial' }">
          <template #icon>
            <van-image class="search-icon" :src="require('@/styles/img/icon_add_materials.png')" />
            <!-- <van-icon name="search" class="search-icon" /> -->
          </template>
        </van-cell>
      </div>
    </van-popup>
  </div>
</template>

<script>
import InvoiceList from '../../components/List/InvoiceList'
import SearchBar from '../../components/SearchBar'
export default {
  name: "Invoice",
  components: {
    InvoiceList,
    SearchBar
  },
  data() {
    return {
      addOrderShow: false,
      svalue:'',
      active:0,
      token:localStorage.getItem('token'),
      tabs: [
        {
            id:'0',
            label:'全部',
        },
        {
            id:'1',
            label:'未开始',
        },
        {
            id:'2',
            label:'进行中',
        },
        {
            id:'3',
            label:'已完成',
        }
      ],
      num: '',//发货单号
      bId: '',//运输单id 查询运输单对应的发货单
      status: '',// 发货单状态 1未开始 2进行中 3已完成
      currentPage: '',// 当前页数
      showCount: '',//显示个数
      token: ''
    };
  },
  created() {
    this.token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
//     window.addEventListener('message', function (e) {
//       const message = e.data;//字符串类型
//       console.log('WebView message:', message);
//       // 接收来自 RN 的参数
// //      alert(message);
//     })
  },
  methods: {
    onClick(name, title) {
      this.status = name
      this.bus.$emit('tabsId', {
        tabsId: name
      })
    },
    onSearch(val) {
      this.bus.$emit('svalue', {
        svalue: val
      })
    },
    // //发送给 RN
    _onSendtoRnPage(){
      this.addOrderShow = true
      // let data = '';
      // window.ReactNativeWebView.postMessage(data);
    }
  },
  destroyed() {
  }
};
</script>
<style scoped lang="less">
  @import '../../styles/order.less';
</style>



// WEBPACK FOOTER //
// src/pages/Invoice/index.vue